export default "__VITE_ASSET__Ck9CAMje__"